import { gql } from "@apollo/client";

//returns a personIncidentSpecific
export const KNOWN_ASSOCIATES = gql`
  query knownAssociates($personId: ID!, $originatorId: ID!) {
    knownAssociates(personId: $personId, originatorId: $originatorId) {
      id
      person {
        aliases {
          id
          target {
            id
            validPersonAlerts {
              alertType {
                name
                alertLevel
              }
            }
          }
        }
        id
        validPersonAlerts {
          alertType {
            id
            name
            alertLevel
          }
          createdAt
          officer {
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
        }
        personalAttribute {
          id
          firstName
          middleName
          lastName
          dob
        }
      }
      incidentInvolvement {
        id
        name
      }
      incident {
        id
        sealed
        locked
        incidentNumber
        callTime
        address {
          id
          validAddressAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
        }
        personIncidentSpecifics {
          id
          sealed
          juvenile
          yoe
          person {
            id
            aliases {
              id
              target {
                id
                validPersonAlerts {
                  id
                  alertType {
                    id
                    name
                    alertLevel
                  }
                }
              }
            }
            validPersonAlerts {
              alertType {
                id
                name
                alertLevel
              }
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
`;
